import React from 'react';

type Props = {
  href?: string;
  text?: string;
  fullWidth?: boolean;
  className?: string;
};

/**
 * Google sign-in button styled to match the official look.
 * - White background
 * - Light gray border
 * - Google "G" logo at left
 * - Text: "Continue with Google"
 */
export const GoogleButton: React.FC<Props> = ({
  href = `${import.meta.env.VITE_API_URL}/auth/google/login`,
  text = 'Continue with Google',
  fullWidth = false,
  className = '',
}) => {
  return (
    <a
      href={href}
      aria-label={text}
      className={[
        'inline-flex items-center justify-center gap-3',
        'bg-white text-gray-800',
        'border border-gray-300 rounded-lg',
        'shadow-sm hover:bg-gray-50 active:bg-gray-100',
        'px-3 py-2',
        'font-medium',
        fullWidth ? 'w-full' : '',
        className,
      ].join(' ').trim()}
    >
      {/* Google G logo (SVG) */}
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.72 1.22 9.23 3.6l6.9-6.9C35.9 1.9 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l8.93 6.93C13.51 13.06 18.33 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.5 24c0-1.64-.15-3.2-.43-4.7H24v9.1h12.65c-.55 2.95-2.2 5.45-4.68 7.12l7.16 5.56C43.87 37.05 46.5 31.1 46.5 24z" />
        <path fill="#FBBC05" d="M11.49 28.15A14.49 14.49 0 0 1 10.5 24c0-1.44.25-2.83.7-4.15l-8.93-6.93A24 24 0 0 0 0 24c0 3.86.9 7.5 2.56 10.78ל8.93-6.93z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.91-5.8l-7.16-5.56c-2 1.35-4.56 2.16-8.75 2.16-5.67 0-10.49-3.56-12.51-8.72ל-8.93 6.93C6.51 42.62 14.62 48 24 48z" />
        <path fill="none" d="M0 0h48v48H0z" />
      </svg>
      <span>{text}</span>
    </a>
  );
};

export default GoogleButton;
